import { Outlet } from "react-router"
import { PublishedPageGuard } from "source/shared/guards/PublishedPageGuard"

export default function CalendarGuardLayout() {
  return (
    <PublishedPageGuard identifier="calendar">
      <Outlet />
    </PublishedPageGuard>
  )
}
